import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const postCalendarGenerateMonth = ({ month }) => {
  return api.post(`/admin/calendar/generate-month`, { month });
};

export const usePostCalendarGenerateMonthMutation = ({
  mutationConfig,
} = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: postCalendarGenerateMonth,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.invalidateQueries({ queryKey: ["calendars"] });
      queryClient.invalidateQueries({ queryKey: ["calendar"] });
      queryClient.invalidateQueries({ queryKey: ["calendar-date-range"] });
    },
    ...restConfig,
  });
};
